import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://portal.nxc-emge.de/api',
});

// Access Token automatisch mitsenden
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// Laufenden Refresh-Request cachen
let refreshPromise = null;

// Bei 401 automatisch Token erneuern
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) throw new Error('no refresh token');

        // Laufenden Refresh wiederverwenden statt neu starten
        if (!refreshPromise) {
          refreshPromise = axios.post(
            (process.env.REACT_APP_API_URL || 'https://portal.nxc-emge.de/api') + '/auth/refresh',
            { refreshToken }
          ).finally(() => { refreshPromise = null; });
        }

        const res = await refreshPromise;
        localStorage.setItem('accessToken', res.data.accessToken);
        if (res.data.refreshToken) {
          localStorage.setItem('refreshToken', res.data.refreshToken);
        }
        original.headers.Authorization = 'Bearer ' + res.data.accessToken;
        return api(original);
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403 || err.message === 'no refresh token') {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
        }
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
